import React from "react";
import PropTypes from 'prop-types'
import { ButtonCommonTop, ShowCaseDiv, SubNavBarActiveDiv } from "../../pages/Theme";

const ShowcaseLink = ({data, onClick, ...props}) => {
    return(
        <ShowCaseDiv className={"flex flex-row items-center mb-0 mx-5 hover:opacity-80 cursor-pointer "} 
            onClick={onClick}
        >
            <div className="mr-2">
                { props.children }
            </div>
        
            <p className="font-semibold whitespace-nowrap text-sm mr-2">{ data.name }</p> 
            <p className="font-semibold text-sm">({ data.posts ? data.posts.length : 0 })</p>
        </ShowCaseDiv>
    )
}

ShowcaseLink.propTypes = {
    image: PropTypes.string,
    showcaseName: PropTypes.string,
    showcaseId: PropTypes.number,
    onClick: PropTypes.func,
}

export default ShowcaseLink